module.exports = __webpack_public_path__ + "static/img/KJY_nav1.d77bb1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon/KJY_nav1.png
// module id = K1aY
// module chunks = 1